import {
    dismissQuoteSummary,
    setSelectedBaseCurrency,
    showQuoteSummary,
    toggleCrm,
    toggleSidebar,
    toggleSidebarView,
} from '@oneview/redux/misc/miscActions';
import { createReducer } from '@reduxjs/toolkit';

export const MISC_REDUCER_DEFAULT_STATE: {
    crmOpened: boolean;
    sidebarOpened: boolean;
    sidebarPermanent: boolean;
    quoteSummarySymbol: string;
    selectedBaseCurrency: string;
} = {
    crmOpened: false,
    sidebarOpened: false,
    sidebarPermanent: true,
    quoteSummarySymbol: '',
    selectedBaseCurrency: '',
};

export const miscReducer = createReducer(MISC_REDUCER_DEFAULT_STATE, (builder) => {
    builder.addCase(toggleCrm, (state) => {
        state.crmOpened = !state.crmOpened;
    });
    builder.addCase(toggleSidebar, (state) => {
        state.sidebarOpened = !state.sidebarOpened;
    });
    builder.addCase(toggleSidebarView, (state) => {
        state.sidebarPermanent = !state.sidebarPermanent;
    });
    builder.addCase(showQuoteSummary, (state, action) => {
        state.quoteSummarySymbol = action.payload;
    });
    builder.addCase(setSelectedBaseCurrency, (state, action) => {
        state.selectedBaseCurrency = action.payload;
    });
    builder.addCase(dismissQuoteSummary, (state) => {
        state.quoteSummarySymbol = '';
    });
});
